import { AvatarModal } from '@public/components/Modals/Player/Avatar';
import { ContactModal } from '@public/components/Modals/Player/Contact';
import { DetailsModal } from '@public/components/Modals/Player/Details';
import { NcaaIdModal } from '@public/components/Modals/Player/NcaaId';
import { CreateSportModal } from '@public/components/Modals/Player/Sport/Create';
import { UpdateSportModal } from '@public/components/Modals/Player/Sport/Update';
import { CreateTeamModal } from '@public/components/Modals/Player/Team/Create';
import { UpdateTeamModal } from '@public/components/Modals/Player/Team/Update';
import { TeamVisitsModal } from '@public/components/Modals/Player/Team/Visits';
import { VitalModal } from '@public/components/Modals/Player/Vital';
import { type ComponentProps } from 'react';

export type PlayerModalType =
  | 'player.avatar'
  | 'player.contact'
  | 'player.details'
  | 'player.details.ncaaId'
  | 'player.sport.create'
  | 'player.sport.update'
  | 'player.team.create'
  | 'player.team.update'
  | 'player.team.visits'
  | 'player.vital';

export interface PlayerModalPropsMap {
  'player.avatar': ComponentProps<typeof AvatarModal>;
  'player.contact': ComponentProps<typeof ContactModal>;
  'player.details': ComponentProps<typeof DetailsModal>;
  'player.details.ncaaId': ComponentProps<typeof NcaaIdModal>;
  'player.sport.create': ComponentProps<typeof CreateSportModal>;
  'player.sport.update': ComponentProps<typeof UpdateSportModal>;
  'player.team.create': ComponentProps<typeof CreateTeamModal>;
  'player.team.update': ComponentProps<typeof UpdateTeamModal>;
  'player.team.visits': ComponentProps<typeof TeamVisitsModal>;
  'player.vital': ComponentProps<typeof VitalModal>;
}

export const playerModals = {
  'player.avatar': AvatarModal,
  'player.contact': ContactModal,
  'player.details': DetailsModal,
  'player.details.ncaaId': NcaaIdModal,
  'player.sport.create': CreateSportModal,
  'player.sport.update': UpdateSportModal,
  'player.team.create': CreateTeamModal,
  'player.team.update': UpdateTeamModal,
  'player.team.visits': TeamVisitsModal,
  'player.vital': VitalModal,
};
